import { SupabaseClient } from "@supabase/supabase-js"
import { downloadFile } from "./downloadFile"
import { BlobRow } from "../../types/supabase"
import { convertImageBlobToPdf } from "./convertImageBlobToPdf"

export async function downloadBlob(
  blob: Pick<BlobRow, 'file_full_path' | 'file_name' | 'content_type'>,
  { client, convertImagesToPdf = false }: { client: SupabaseClient; convertImagesToPdf?: boolean }
) {
  const file = await client.storage.from('wcc-hra-calculator-private').download(blob.file_full_path)
  if (file.error) { throw new Error(file.error.message, { cause: file.error }) }

  if (convertImagesToPdf) {
    const { data, fileName } = await convertImageBlobToPdf(file.data, blob)
    downloadFile(fileName, data)
    return
  }

  downloadFile(blob.file_name, file.data)
}
